<nav class="nav navbar navbar-expand-lg navbar-light iq-navbar"
     (mouseleave)="showNone()" (focus)="showNone()">
  <div class="container-fluid navbar-inner">
    <acc-logo/>
    <div class="sidebar-toggle" data-toggle="sidebar" data-active="true"
         (click)="toggleSidebarState()" (keydown.enter)="toggleSidebarState()" tabindex="0">
      <i class="icon">
        <fa-icon [icon]="sidebarIcon"/>
      </i>
    </div>
    <!-- Global Search - not implemented - https://gitlab.com/epicaccounting/accounting/-/issues/1
    <div class="input-group search-input">
      <span class="input-group-text" id="search-input">
        <svg class="icon-18" width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="11.7669" cy="11.7666" r="8.98856" stroke="currentColor" stroke-width="1.5"
          stroke-linecap="round" stroke-linejoin="round"></circle>
          <path d="M18.0186 18.4851L21.5426 22" stroke="currentColor" stroke-width="1.5"
          stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </span>
      <input type="search" class="form-control" placeholder="{{'search.placeholder'|translate}}">
    </div>
    -->
    @if (org) {
      <div class="fw-bold fs-5 acc-org-name">
        {{ org.name }}
      </div>
    }

    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon">
        <span class="mt-2 navbar-toggler-bar bar1"></span>
        <span class="navbar-toggler-bar bar2"></span>
        <span class="navbar-toggler-bar bar3"></span>
      </span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="mb-2 navbar-nav ms-auto align-items-lg-center navbar-list mb-lg-0">

        <!-- Form status START -->
        @if (showFormStatus) {
          <li class="nav-item" (mouseover)="showNone()" (focus)="showNone()">
            <div class="nav-link d-flex align-items-center" [ngbPopover]="formStatusText" popoverClass="popover-pre-line">
              <acc-icon name="form-status" [styling]="formStatus" [size]="2"/>
              <span class="ms-3 d-lg-none">{{ ('form.status.' + formStatus) | translate }}</span>
            </div>
          </li>
        }
        <!-- Form status END -->

        <!-- notification START -->
        <li class="nav-item dropdown">
          <a href="#" class="nav-link d-flex align-items-center" id="notification-drop"
             (click)="openNotification($event)" (mouseover)="showNotification()" (focus)="showNotification()">
            <acc-icon name="notification" [size]="2" [styling]="nfs?.getStyling()"/>
            @if (nfs && nfs.getSumUnread() > 0) {
              <span class="notification-badge position-absolute translate-middle badge rounded-pill bg-dark">
                {{ nfs.getSumUnread() }}
              </span>
            }
            <span class="ms-3 d-lg-none">{{ 'notification.names' | translate }}</span>
          </a>
          <div class="p-0 sub-drop dropdown-menu dropdown-menu-end" aria-labelledby="notification-drop"
               [class.show]="isShowNotification()" [attr.data-bs-popper]="isShowNotification() ? 'static' : false">
            <div class="m-0 shadow-none card">
              <a routerLink="/notifications">
                <div class="py-3 card-header d-flex justify-content-between bg-primary">
                  <div class="header-title">
                    <h5 class="mb-0 text-white">{{ 'notification.names' | translate }}</h5>
                  </div>
                </div>
              </a>
              <div class="p-0 card-body">
                @if (nfs?.notifications?.length === 0) {
                  <div class="iq-sub-card">
                    <div class="d-flex align-items-center">
                      <div class="ms-3 w-100">
                        <p class="mb-0 ">{{ 'notification.empty'|translate }}</p>
                      </div>
                    </div>
                  </div>
                }
                @for (nf of nfs?.notifications; track nf.id) {
                  <a class="iq-sub-card"
                     [class.text-bg-warning]="nf.level === 'WARNING'"
                     (click)="notifyClick(nf)" (keydown.enter)="notifyClick(nf)" tabindex="0">
                    <div class="d-flex align-items-center">
                      <div>
                        @if (nf.isNew()) {
                          <acc-icon name="new"/>
                        }
                        @if (nf.isWarning()) {
                          <acc-icon name="warn"/>
                        }
                      </div>
                      <div class="ms-3 w-100">
                        <p class="mb-0">{{ nf.hasTranslation() ? (nf.message | translate) : nf.message }}</p>
                      </div>
                    </div>
                  </a>
                }
              </div>
            </div>
          </div>
        </li>
        <!-- notification END -->

        <!-- Org-Switch START -->
        <li class="nav-item dropdown">
          <a class="search-toggle nav-link d-flex align-items-center" id="dropdownMenuButton2"
             aria-haspopup="true" aria-expanded="false"
             (click)="routeOrgList()" (keydown.enter)="routeOrgList()" tabindex="0"
             (mouseover)="showOrg()" (focus)="showOrg()">
            <acc-icon name="org-switch" [size]="2"/>
            <span class="bg-primary"></span>
            <span class="ms-3 d-lg-none">{{ 'orgs' | translate }}</span>
          </a>
          <div class="p-0 sub-drop dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton2"
               [class.show]="isShowOrg()" [attr.data-bs-popper]="isShowOrg() ? 'static' : false">
            <div class="m-0 border-0 shadow-none card">
              <a (click)="routeOrgList()" (keydown.enter)="routeOrgList()" tabindex="0">
                <div class="py-3 card-header d-flex justify-content-between bg-primary">
                  <div class="header-title">
                    <h5 class="mb-0 text-white">{{ 'orgs' | translate }}</h5>
                  </div>
                </div>
              </a>
              <div class="p-0 ">
                <ul class="p-0 list-group list-group-flush">
                  @if (isStateOrg) {
                    <li class="iq-sub-card list-group-item"
                        (click)="useUser()" (keydown.enter)="useUser()" tabindex="0">
                      {{ 'user.use'|translate }}
                    </li>
                  }
                  @for (org of getActiveOrgs(); track org.id) {
                    <li class="iq-sub-card list-group-item"
                        (click)="useOrg(org.id)" (keydown.enter)="useOrg(org.id)" tabindex="0">
                      {{ org.name }}
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </li>
        <!-- Org-Switch END -->

        <!-- User START -->
        <li class="nav-item dropdown">
          <a class="py-0 nav-link d-flex align-items-center" id="navbarDropdown" role="button"
             data-bs-toggle="dropdown" aria-expanded="false"
             [routerLink]="Paths.USER_PROFILE"
             (mouseover)="showUser()" (focus)="showUser()">
            <acc-icon name="user" [size]="2" styling="primary"/>
            <span class="ms-3 d-md-none">{{ 'profile' | translate }}</span>
            <div class="caption ms-3 d-none d-md-block ">
              <h6 class="mb-0 caption-title">{{ user?.getUsername() }}</h6>
              @if (user?.hasFirstname()) {
                <p class="mb-0 caption-sub-title">{{ user.getPrimeEmail()?.email }}</p>
              }
            </div>
          </a>
          <div class="p-0 sub-drop dropdown-menu dropdown-menu-end"
               aria-labelledby="navbarDropdown"
               [class.show]="isShowUser()" [attr.data-bs-popper]="isShowUser() ? 'static' : false">
            <div class="m-0 border-0 shadow-none card">
              <a [routerLink]="Paths.USER_PROFILE">
                <div class="py-3 card-header d-flex justify-content-between bg-primary">
                  <div class="header-title">
                    <h5 class="mb-0 text-white">{{ 'profile' | translate }}</h5>
                  </div>
                </div>
              </a>
              <div class="p-0 ">
                <ul class="p-0 list-group list-group-flush acc-user-dropdown-menu">
                  <li class="iq-sub-card list-group-item" [routerLink]="Paths.USER_PROFILE">
                    {{ 'profile' | translate }}
                  </li>
                  <li class="iq-sub-card list-group-item" [routerLink]="Paths.USER_LAYOUT">
                    {{ 'layout' | translate }}
                  </li>
                  @if (!isIronBackupViewer) {
                    <li>
                      <hr class="dropdown-divider">
                    </li>
                    <li class="iq-sub-card list-group-item"
                        (click)="signout()" (keydown.enter)="signout()" tabindex="0">
                      {{ 'user.signout' | translate }}
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
          <!--<ul class="dropdown-menu dropdown-menu-end acc-user-dropdown-menu" aria-labelledby="navbarDropdown"
          [class.show]="showUserMenu" [attr.data-bs-popper]="showUserMenu ? 'static' : false">
          <li><a class="dropdown-item" [routerLink]="Paths.USER_PROFILE">{{ 'profile' | translate }}</a></li>
          <li><a class="dropdown-item" [routerLink]="Paths.USER_LAYOUT">{{ 'layout' | translate }}</a></li>
          <li>
            <hr class="dropdown-divider">
          </li>
          <li><a class="dropdown-item link"
          (click)="signout()" (keydown.enter)="signout()" tabindex="0">{{ 'user.signout' | translate }}</a>
        </li>
      </ul>-->
        </li>
        <!-- User END -->
      </ul>
    </div>
  </div>
</nav>
